import script from "./driverInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./driverInfoList.vue?vue&type=script&setup=true&lang=js"

import "./driverInfoList.vue?vue&type=style&index=0&id=7e9b3206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9b3206"]])

export default __exports__